import { render, staticRenderFns } from "./ProductExplanation.vue?vue&type=template&id=0c0cd1a4&scoped=true"
import script from "./ProductExplanation.vue?vue&type=script&lang=js"
export * from "./ProductExplanation.vue?vue&type=script&lang=js"
import style0 from "./ProductExplanation.vue?vue&type=style&index=0&id=0c0cd1a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0cd1a4",
  null
  
)

export default component.exports